var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 181,
    viewBox: "0 0 180 181",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18337_130192)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_18337_130192)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.988281 137.419V160.958C0.988281 164.343 3.75635 167.111 7.14086 167.111C13.7479 167.111 16.6345 161.891 16.6345 161.891L17.0711 59.3419L22.4828 53.7563L166.505 47.8744V44.9463C166.505 40.2124 162.668 36.3754 157.934 36.3754H100.244C97.9715 36.3754 95.7902 35.4725 94.1839 33.8662L76.5145 16.1967C74.9082 14.5904 72.7269 13.6875 70.4548 13.6875H9.55922C4.82525 13.6875 0.988281 17.5245 0.988281 22.2584V36.3774V40.9849V137.419Z",
    fill: "#007AFF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dd_18337_130192)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.14062 167.111C10.5251 167.111 13.2932 164.343 13.2932 160.959V56.4361C13.2932 51.708 17.1262 47.875 21.8543 47.875H170.249C174.977 47.875 178.81 51.708 178.81 56.4361V158.552C178.81 163.28 174.977 167.113 170.249 167.113L7.14062 167.111Z",
    fill: "#007AFF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M98.4306 138H82.5694C79.7765 138 77.5071 136.131 77.5071 133.832V114.138C76.106 114.284 74.6397 113.914 73.5684 113.029L61.8862 103.414C60.9919 102.678 60.4981 101.699 60.5 100.656C60.5 99.6152 60.9937 98.6383 61.8881 97.9037L87.1528 77.1042C88.9396 75.6319 92.0623 75.6319 93.8491 77.1042L119.114 97.9068C120.006 98.6398 120.5 99.6167 120.5 100.658C120.5 101.701 120.008 102.678 119.114 103.415L107.43 113.031C106.357 113.914 104.89 114.285 103.491 114.139V133.833C103.491 136.131 101.222 138 98.4306 138ZM83.0948 133.399H97.9015V104.19L104.084 109.278L114.555 100.661L90.4991 80.8568L66.4417 100.661L76.9128 109.278L83.0948 104.194V133.399Z",
    fill: "white",
    fillOpacity: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_18337_130192",
    x: -3.01172,
    y: 13.6875,
    width: 173.516,
    height: 161.422,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_18337_130192"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_18337_130192",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dd_18337_130192",
    x: 3.14062,
    y: 47.875,
    width: 179.668,
    height: 127.242,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_18337_130192"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_18337_130192",
    result: "effect2_dropShadow_18337_130192"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_18337_130192",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18337_130192"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/uploadIcon.cc589238441ef62a699ae06b27face81.svg";
export { ForwardRef as ReactComponent };